import { render, staticRenderFns } from "./AccessSettingsIndex.vue?vue&type=template&id=104887ae"
import script from "./AccessSettingsIndex.vue?vue&type=script&lang=js"
export * from "./AccessSettingsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports